/// <reference path="../../../../Scripts/typings/less/less.d.ts" />
define('areas/home/commands/changecolorcommand',["require", "exports"], function (require, exports) {
    "use strict";
    var ChangeColorCommand = (function () {
        function ChangeColorCommand() {
        }
        ChangeColorCommand.prototype.execute = function (symbol) {
            less.modifyVars({ "main-blue": symbol, "blue": symbol, "brand-primary": symbol, "btn-primary-bg": symbol });
        };
        return ChangeColorCommand;
    }());
    return ChangeColorCommand;
});

